import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/concat';
import 'rxjs/add/observable/dom/ajax';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/distinct';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/pluck';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/switchMap';

class AssignmentAbstract {
    id: number;
    firstName: string;
    lastName: string;
    title: string;
    programedInSession: number;
    presentationType: string;
    score?: number;
}

let placeHolderAbstract: AssignmentAbstract = {
    id: 0,
    firstName: '',
    lastName: '',
    score: 0,
    programedInSession: 0,
    presentationType: '',
    title: '',
};

let errorAbstract: AssignmentAbstract = {
    id: 0,
    firstName: '',
    lastName: '',
    score: 0,
    programedInSession: 0,
    presentationType: 'Invalid',
    title: '',
};

export let abstractAutocompletes = [] as Array<AbstractAutocomplete>;

class AbstractAutocomplete {

    constructor(
        private getUrl: string,
        private abstractDetailUrl: string,
        private sessionId: string) {
    }
    // Setup the pipeline for all the input elements
    addInputPipelineAllInput() {
        var inputs = document.querySelectorAll('input.program-assignment-abstract-id');
        var i = 0;
        for (i = 0; i < inputs.length; i++) {
            let input = inputs[i] as HTMLInputElement;
            this.addInputPipeline(input);
        }
    }

    // Setup the pipeline for input inside this row. (For new row)
    addInputPipelineFromRow(rowElement: HTMLTableRowElement) {
        var input = rowElement.querySelector('input.program-assignment-abstract-id') as HTMLInputElement;
        this.addInputPipeline(input);
    }

    private addInputPipeline(inputElement: HTMLInputElement) {
        var keyups = Observable.fromEvent(inputElement, 'keyup');
        keyups = keyups.startWith({ target: { value: inputElement.value } });
        var textStream = keyups.pluck('target', "value") as Observable<string>;
        var parent = inputElement.parentNode.parentNode;
        var distinct = textStream.filter((a) => {
            if (a.length == 4) {
                return true;
            }
            else {
                this.setHtml(parent, placeHolderAbstract);
                return false;
            }
        });
        distinct.switchMap((a) => {
            return this.getAbstractSummary(a);
        }).subscribe((data) => {
            this.setHtml(parent, data);
        });
    }

    private getAbstractSummary(absno: string): Observable<AssignmentAbstract> {
        return Observable.ajax({
            method: "GET",
            url: this.getUrl + "?AbstractId=" + absno + "&SessionId=" + this.sessionId,
        }).map(function (data) {
            return data.response;
        }).catch(function () {
            return Observable.of(errorAbstract);
        });
    }

    private setHtml(parent, response: AssignmentAbstract) {
        let a = parent.querySelector('.program-assignment-abstract-author') as HTMLAnchorElement;
        let errorContainerElem = a.parentElement;
        let titleElem = parent.querySelector('.program-assignment-abstract-title') as HTMLDivElement;
        errorContainerElem.classList.remove("program-assignment-abstract-warning");
        errorContainerElem.classList.remove("program-assignment-abstract-error");

        if (!response) {
            a.removeAttribute("href");
            a.textContent = 'Invalid';
            errorContainerElem.classList.add("program-assignment-abstract-error");
            titleElem.textContent = 'Invalid Abstract Number';
        //} else if (response.presentationType === 'Poster' || response.presentationType === 'Invalid') {
        } else if (response.presentationType === 'Invalid') {
            a.removeAttribute("href");
            a.textContent = 'Invalid';
            errorContainerElem.classList.add("program-assignment-abstract-error");
            titleElem.textContent = response.presentationType;
        } else {
            a.textContent = response.firstName + " " + response.lastName;
            a.href = this.abstractDetailUrl + '/' + response.id;
            let title = response.title;
            if (response.programedInSession) {
                title = "<span class='text-danger'>Already Programed in Session " + response.programedInSession + "</span> " + title;
                errorContainerElem.classList.add("program-assignment-abstract-warning");
            }
            titleElem.innerHTML = title;
        }
    }
}

export default function () {
    var programAssigmentElems = document.querySelectorAll("[data-gs-program-assignment]");
    if (programAssigmentElems.length == 0) {
        return;
    }
    for (let i = 0; i < programAssigmentElems.length; i++) {
        let programAssigmentElem = programAssigmentElems[i] as HTMLElement;
        let sessionId = programAssigmentElem.dataset["gsProgramAssignmentSessionId"];
        if (!sessionId) {
            console.log("sessionId can not be found", programAssigmentElem);
        }
        let getUrl = programAssigmentElem.dataset["gsProgramAssignmentApiUrl"];
        if (!getUrl) {
            console.log("getUrl can not be found", programAssigmentElem);
        }
        let abstractDetailUrl = programAssigmentElem.dataset["gsProgramAssignmentAbstractDetailUrl"];
        if (!abstractDetailUrl) {
            console.log("abstractDetail can not be found", programAssigmentElem);
        }

        let abstractAutocomplete = new AbstractAutocomplete(getUrl, abstractDetailUrl, sessionId);
        abstractAutocomplete.addInputPipelineAllInput();
        abstractAutocompletes.push(abstractAutocomplete);
    }
}
